import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store.js";
import HomePage from "./pages/HomePage.jsx";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import theme from "./theme/theme.js";
import "react-quill/dist/quill.snow.css";
import "./theme/GlobalStyles.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ErrorAlert from "./components/common/ErrorAlert.jsx";

function App() {
  return (
    <GoogleOAuthProvider clientId="605862642507-oeqgdg00jvfpsbjcss67h7qk9cdf3pqr.apps.googleusercontent.com">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorAlert />
            <HomePage />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  );
}

export default App;
